// src/data/libraryWorks.js

export const works = [
  {
    id: "w1",
    title: "Night in The Woods",
    author: "john.doe",
    genre: "Psychological",
    fandom: "Original",
    language: "Chinese",
    wordCount: 20000,
    views: 1024,
    tags: ["Hurt/Comfort", "Found Family", "Trauma", "Emotional Healing", "Friendship"],
  },
  {
    id: "w2",
    title: "Ashes of the Crown",
    author: "xi9283",
    genre: "Fantasy",
    fandom: "Original",
    language: "Turkish",
    wordCount: 54000,
    views: 873,
    tags: ["Enemies to Lovers", "Slow Burn", "Redemption Arc", "Forbidden Romance", "Violence"],
  },
  {
    id: "w3",
    title: "Untitled Draft",
    author: "a82762",
    genre: "Drama",
    fandom: "Original",
    language: "Japanese",
    wordCount: 8200,
    views: 214,
    tags: ["Hurt/Comfort", "Trauma", "Emotional Healing", "One Shot"],
  },
  {
    id: "w4",
    title: "The Last Signal",
    author: "amira575",
    genre: "Sci-Fi",
    fandom: "Original",
    language: "English",
    wordCount: 31200,
    views: 641,
    tags: ["Amnesia", "Time Loop", "Canon Universe", "Slow Burn", "Miscommunication"],
  },
  {
    id: "w5",
    title: "Fragments",
    author: "gooner",
    genre: "Experimental",
    fandom: "Original",
    language: "English",
    wordCount: 4600,
    views: 97,
    tags: ["One Shot", "Canon Divergence", "Alternate Universe"],
  },
  {
    id: "w6",
    title: "Cold Water",
    author: "john.doe",
    genre: "Thriller",
    fandom: "Original",
    language: "English",
    wordCount: 17800,
    views: 388,
    tags: ["Violence", "Blood and Injury", "Major Character Death", "Hurt/Comfort"],
  },
];

